import React, { useEffect, useTransition } from "react";
import { Box } from "@mui/material";
import FreeTextCard from "./components/FreeTextCard";
import { MODES } from "utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { selectAnswer } from "app/containers/Questions/redux/selector";
import { FreeTextAnswer } from "app/containers/Questions/types";
import { actions } from "app/containers/Questions/redux/slice";
import useDebounceEffect from "utils/hooks/useDebounceEffect";
import PrimaryButton from "app/components/Buttons/PrimaryButton";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";

const MAX_ANSWER = 2;
const Data: FreeTextAnswer ={
    _id: "",
    letters: [
      {
        _id: "",
        isVisible: false,
        isDelete: false,
        option1: "",
        option2: "",
      },
      {
        _id: "",
        isVisible: false,
        isDelete: false,
        option1: "",
        option2: "",
      },
      {
        _id: "",
        isVisible: false,
        isDelete: false,
        option1: "",
        option2: "",
      },
      {
        _id: "",
        isVisible: false,
        isDelete: false,
        option1: "",
        option2: "",
      },
      {
        _id: "",
        isVisible: false,
        isDelete: false,
        option1: "",
        option2: "",
      },
      {
        _id: "",
        isVisible: false,
        isDelete: false,
        option1: "",
        option2: "",
      },
      {
        _id: "",
        isVisible: false,
        isDelete: false,
        option1: "",
        option2: "",
      },
    ],
  }



const FreeText = ({ disabled, mode }: { disabled?: boolean; mode: MODES }) => {
  const {t} = useTranslation()
  const dispatch = useDispatch();
  const answer = useSelector(selectAnswer);
  const maxNotReached = (answer.free_text?.length ?? 0) < MAX_ANSWER;
  const disabledDelete = answer?.free_text?.length == 1 || disabled;
  useDebounceEffect(
    () => {
      if (!answer?.free_text?.length) {
        dispatch(actions.setFreeTextAnswer(Data));
        return;
      }

      return () => {};
    },
    [answer?.free_text,],
    100
  );

   const handleAddAnswer = () => {
      if (maxNotReached) {
        dispatch(actions.setFreeTextAnswer(Data));
        return;
      }
    };


  

  return (
    <>
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        marginBottom: "20px",
      }}
    >
      {answer.free_text?.map((item, index) => {
        return (
          <FreeTextCard
            isPlotRTL={item?.isPlotRTL  || false}
            key={index}
            dataIndex={index}
            data={item?.letters || []}
            disabled={disabled}
            disabledDelete={disabledDelete}
          />
        );
      })}
    </Box>
    <Box display={'flex'} justifyContent={'flex-end'} marginBottom={'40px'}>
      <PrimaryButton
              sx={{ width: 145 }}
              startIcon={<AddIcon />}
              disabled={!maxNotReached}
              onClick={handleAddAnswer}
              label={t("COMMON.BUTTONS.ADD_NEW_ANSWER")}
            />
    </Box>
    </>
  );
};

export default FreeText;
